import React, { useEffect, useRef } from "react";
import styles from "./index.module.scss";
import cn from "../../../../../Utils/class-names.utils";
import { IEmailTemplateFormValues } from "../../../../../common/validations/email-templates.validations";
import { ReactElement } from "react";

interface InviteTemplateProps<T extends IEmailTemplateFormValues> {
  formValues: T;
  width?: number;
  isMobileView?: boolean;
  onHeightChange?: (height: number) => void;
  previewComponent: (formValues: T) => ReactElement;
}

const InviteTemplate = <T extends IEmailTemplateFormValues>({ 
  formValues, 
  width, 
  isMobileView, 
  onHeightChange,
  previewComponent
}: InviteTemplateProps<T>) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const containerStyle = width ? { width: `${width}px` } : undefined;

  useEffect(() => {
    const updateHeight = () => {
      if (containerRef.current && onHeightChange) {
        requestAnimationFrame(() => {
          if (containerRef.current) {
            const height = containerRef.current.getBoundingClientRect().height;
            onHeightChange(Math.round(height));
          }
        });
      }
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(updateHeight);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [onHeightChange, formValues, width]);

  return (
    <div 
      id="invite-template-container" 
      ref={containerRef}
      className={cn(styles.container, {
        [styles.mobileContainer]: isMobileView,
      })} 
      style={containerStyle}
    >
      {previewComponent(formValues)}
    </div>
  );
};

export default InviteTemplate;
